import { BREAKPOINTS, COLORS, ComponentL } from "@laerdal/life-react-components";
import styled from "styled-components";

export const CaseTitle = styled.h3`
  color: var(--Base-Black, #1F1F1F);
  font-feature-settings: 'liga' off;
  font-family: Lato;
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%;
  margin: 0;

  ${BREAKPOINTS.MEDIUM} {
    font-size: var(--font-size-H3, 40px);
  }
`;

export const CaseSubTitle = styled(ComponentL)`
  color: ${COLORS.neutral_600};
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
`;

export const CaseHeader = styled.div`
    margin: 0 0 32px 0;
`;
